export default __webpack_public_path__ + "b802ba8c30cbdb29c9cc02c3a91570b8.png";